import React, { Fragment, useState, useContext } from "react";
import { loginReq } from "./fetchApi";
import { LayoutContext } from "../index";
import { LogIn } from "lucide-react"; // Ícone de login

const Login = () => {
  const { dispatch: layoutDispatch } = useContext(LayoutContext);
  const [data, setData] = useState({
    phone: "",
    password: "",
    error: "",
    loading: false,
    validationErrors: {},
  });

  const alert = (msg) => <div className="text-xs text-red-500">{msg}</div>;

  const formatPhoneNumber = (value) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    if (cleaned.length <= 2) return `(${cleaned}`;
    if (cleaned.length <= 7)
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(
      7,
      11
    )}`;
  };

  const removeThirdDigit = (value) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    return cleaned.slice(0, 2) + cleaned.slice(3);
  };

  const validateForm = () => {
    const errors = {};
    if (!data.phone) {
      errors.phone = "Digite seu número de telefone.";
    }
    if (!data.password) {
      errors.password = "Digite sua senha.";
    }
    return errors;
  };

  const formSubmit = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setData({ ...data, validationErrors });
      return;
    }

    setData({ ...data, loading: true, error: "", validationErrors: {} });
    try {
      const formattedPhone = removeThirdDigit(data.phone);
      const responseData = await loginReq({
        phone: formattedPhone,
        password: data.password,
      });

      if (responseData.error) {
        setData({
          ...data,
          loading: false,
          error: responseData.error,
          password: "",
        });
      } else if (responseData.token) {
        localStorage.setItem("jwt", JSON.stringify(responseData));
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Erro no processo de login:", error);
      setData({
        ...data,
        loading: false,
        error: "Não foi possível fazer login. Tente novamente.",
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      formSubmit();
    }
  };

  return (
    <Fragment>
      <div className="flex flex-col items-center space-y-4">
        <div className="text-gray-700">
          <LogIn size={48} />
        </div>
        <h1 className="text-2xl font-semibold text-gray-800">
          Bem-vindo de volta!
        </h1>
        <p className="text-gray-600 text-sm">Acesse sua conta para continuar.</p>
      </div>
      <form className="space-y-6 mt-6" onSubmit={(e) => e.preventDefault()}>
        <div className="flex flex-col">
          <label htmlFor="phone" className="text-sm font-medium text-gray-700">
            Número de WhatsApp
          </label>
          <input
            onChange={(e) => {
              const formattedNumber = formatPhoneNumber(e.target.value);
              setData({
                ...data,
                phone: formattedNumber,
                error: "",
                validationErrors: {},
              });
              layoutDispatch({ type: "loginSignupError", payload: false });
            }}
            onKeyPress={handleKeyPress}
            value={data.phone}
            type="text"
            id="phone"
            className={`px-4 py-2 border ${
              data.validationErrors.phone ? "border-red-500" : "border-gray-300"
            } focus:outline-none rounded-lg`}
            placeholder="(11) 91234-5678"
          />
          {data.validationErrors.phone && alert(data.validationErrors.phone)}
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="password"
            className="text-sm font-medium text-gray-700"
          >
            Senha
          </label>
          <input
            onChange={(e) => {
              setData({
                ...data,
                password: e.target.value,
                error: "",
                validationErrors: {},
              });
              layoutDispatch({ type: "loginSignupError", payload: false });
            }}
            onKeyPress={handleKeyPress}
            value={data.password}
            type="password"
            id="password"
            className={`px-4 py-2 border ${
              data.validationErrors.password
                ? "border-red-500"
                : "border-gray-300"
            } focus:outline-none rounded-lg`}
            placeholder="Digite sua senha"
          />
          {data.validationErrors.password &&
            alert(data.validationErrors.password)}
        </div>
        <div className="flex justify-between items-center">
          <div className="text-sm">
            <button
              type="button"
              className="text-gray-500 hover:underline focus:outline-none"
            >
              Esqueceu sua senha?
            </button>
          </div>
        </div>
        <div className="flex justify-center">
          <button
            type="button"
            onClick={formSubmit}
            className="w-full max-w-md bg-gray-800 text-white font-medium px-4 py-3 text-center rounded-lg cursor-pointer transition-all duration-300 ease-in-out hover:bg-gray-700 flex items-center justify-center"
          >
            {data.loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              "Entrar"
            )}
          </button>
        </div>
        {data.error && alert(data.error)}
      </form>
    </Fragment>
  );
};

export default Login;